/**
 * cb-upsell.js  v9  (pkt)
 * ─────────────────────────────────────────────────────────────────────────────
 * 1. Hover "Add to Bag" on .cb-card-item cards in product upsell sections
 * 2. <cb-cart-ymal>  — Cart "You May Also Like" panel
 *    4 products = blend of Recently Viewed + AI recs
 *    Every card has a hover "Add to Bag" button
 * 3. <recently-viewed> enhancement — adds "Add to Bag" overlay to RV cards
 *    (the section's own JS creates the li elements; we watch for them)
 * 4. Discount auto-clear when cart empties
 * ─────────────────────────────────────────────────────────────────────────────
 */
(function () {
  'use strict';

  /* ══════════════════════════════════════════════════════════════════════════
     UTILITIES
  ══════════════════════════════════════════════════════════════════════════ */
  var STORAGE_KEY = 'coolbee_recently_viewed_v1';

  function getRVList() {
    try {
      var raw = JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
      return raw.map(function (item) { return typeof item === 'object' ? item.h : item; });
    }
    catch (e) { return []; }
  }

  function debounce(fn, ms) {
    var t;
    return function () {
      var a = arguments, ctx = this;
      clearTimeout(t);
      t = setTimeout(function () { fn.apply(ctx, a); }, ms);
    };
  }

  function refreshCartCount() {
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('#cart-icon-bubble [aria-hidden="true"]').forEach(function (el) {
          el.textContent = cart.item_count;
        });
        if (window.PUB_SUB_EVENTS && typeof publish === 'function') {
          try { publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cb-upsell', cartData: cart }); }
          catch (e) {}
        }
      }).catch(function () {});
  }

  function openCartDrawer() {
    var drawer = document.querySelector('cart-drawer');
    if (drawer && typeof drawer.open === 'function') drawer.open();
  }

  var BAG_SVG = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" width="14" height="14"><path d="M6 2 3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"/><line x1="3" y1="6" x2="21" y2="6"/><path d="M16 10a4 4 0 0 1-8 0"/></svg>';

  /* ══════════════════════════════════════════════════════════════════════════
     SHARED: inject "Add to Bag" hover overlay on any card li
     Works for .cb-card-item (product sections), .cb-cart-ymal-item (cart),
     and .cb-rv-item (recently viewed).
  ══════════════════════════════════════════════════════════════════════════ */
  function injectATBOverlay(li, opts) {
    if (li.dataset.cbAtbDone) return;
    li.dataset.cbAtbDone = '1';

    opts = opts || {};
    var link = li.querySelector('a[href*="/products/"]');
    var url  = link ? link.getAttribute('href') : null;
    if (!url) return;

    var variantInput = li.querySelector('input[name="id"].product-variant-id');
    var variantId    = variantInput ? variantInput.value : null;
    var hasOptions   = !variantInput && !!li.querySelector('[data-product-url]');

    var overlayClass = opts.overlayClass || 'cb-atb-overlay';
    var btnClass     = opts.btnClass     || 'cb-atb-btn';
    var btnHTML      = opts.iconOnly
      ? '<button class="' + btnClass + '" type="button">' + BAG_SVG + '<span>Add to Bag</span></button>'
      : '<button class="' + btnClass + '" type="button">Add to Bag</button>';

    var overlay = document.createElement('div');
    overlay.className = overlayClass;
    overlay.innerHTML = btnHTML;

    var btn = overlay.querySelector('.' + btnClass);
    btn.addEventListener('click', function (e) {
      e.preventDefault(); e.stopPropagation();
      if (hasOptions || !variantId) { window.location.href = url; return; }
      btn.disabled = true;
      var span = btn.querySelector('span');
      if (span) span.textContent = 'Adding\u2026';
      else btn.textContent = 'Adding\u2026';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: parseInt(variantId, 10), quantity: 1 })
      })
        .then(function (r) { return r.json(); })
        .then(function (d) {
          if (d.status && d.status >= 400) throw new Error(d.description || 'Error');
          if (span) span.textContent = 'Added!';
          else btn.textContent = 'Added!';
          refreshCartCount();
          if (opts.reloadAfter) {
            setTimeout(function () { window.location.reload(); }, 700);
          } else {
            openCartDrawer();
            setTimeout(function () {
              btn.disabled = false;
              if (span) span.textContent = 'Add to Bag';
              else btn.textContent = 'Add to Bag';
            }, 1800);
          }
        })
        .catch(function () {
          btn.disabled = false;
          if (span) span.textContent = 'Add to Bag';
          else btn.textContent = 'Add to Bag';
          window.location.href = url;
        });
    });

    var mediaWrap = li.querySelector('.card__media, .card__inner');
    if (mediaWrap) {
      mediaWrap.style.position = 'relative';
      mediaWrap.style.overflow = 'hidden';
      mediaWrap.appendChild(overlay);
    } else {
      li.style.position = 'relative';
      li.appendChild(overlay);
    }
  }

  /* ══════════════════════════════════════════════════════════════════════════
     1. HOVER ATB — .cb-card-item (product upsell sections)
  ══════════════════════════════════════════════════════════════════════════ */
  function decorateUpsellCards(root) {
    (root || document).querySelectorAll('li.cb-card-item:not([data-cb-atb-done])').forEach(function (li) {
      injectATBOverlay(li, { overlayClass: 'cb-atb-overlay', btnClass: 'cb-atb-btn', iconOnly: true });
    });
  }

  /* ══════════════════════════════════════════════════════════════════════════
     2. RECENTLY VIEWED — enhance cards with "Add to Bag" overlay
     The section's own JS creates the li.grid__item cards; we watch for them
     and inject ATB overlays with the same styling as the YMAL panel.
  ══════════════════════════════════════════════════════════════════════════ */
  function decorateRVCards(root) {
    // The RV section creates li.grid__item inside [data-recently-viewed-grid]
    var grids = (root || document).querySelectorAll('[data-recently-viewed-grid]');
    grids.forEach(function (grid) {
      grid.querySelectorAll('li.grid__item:not([data-cb-atb-done])').forEach(function (li) {
        // Add the same visual class as YMAL items so CSS hover works
        li.classList.add('cb-ymal-item-style');
        injectATBOverlay(li, {
          overlayClass: 'cb-ymal-atb-overlay',
          btnClass:     'cb-ymal-atb-btn'
        });
      });
    });
  }

  /* ══════════════════════════════════════════════════════════════════════════
     3. <cb-cart-ymal> — Cart "You May Also Like" Panel
     4 products = Recently Viewed slots + AI recommendation slots
  ══════════════════════════════════════════════════════════════════════════ */
  if (!window.customElements.get('cb-cart-ymal')) {

    var CbCartYmal = function () { HTMLElement.call(this); };
    CbCartYmal.prototype = Object.create(HTMLElement.prototype);
    CbCartYmal.prototype.constructor = CbCartYmal;

    CbCartYmal.prototype.connectedCallback = function () {
      var self = this;
      // 500ms ensures Shopify's cart HTML is fully in the DOM
      setTimeout(function () { self._boot(); }, 500);
    };

    CbCartYmal.prototype._cartHandles = function () {
      var out = [];
      document.querySelectorAll('a.cart-item__name, a.cart-item__link').forEach(function (a) {
        var after = (a.getAttribute('href') || '').split('/products/')[1];
        if (!after) return;
        var h = after.split('?')[0].split('#')[0].toLowerCase();
        if (h && out.indexOf(h) === -1) out.push(h);
      });
      return out;
    };

    /* Fetch one RV card as a themed DOM element */
    CbCartYmal.prototype._fetchRVCard = function (handle) {
      return fetch('/products/' + encodeURIComponent(handle) + '?section_id=recently-viewed-card')
        .then(function (r) { return r.ok ? r.text() : null; })
        .then(function (html) {
          if (!html) return null;
          var tmp = document.createElement('div');
          tmp.innerHTML = html;
          /*
           * FIX: Do NOT rely on the Shopify-generated wrapper ID
           * (e.g. #shopify-section-template--XYZ__recently-viewed-card).
           * Scan the entire response for the first .card-wrapper element.
           */
          var card = tmp.querySelector('.card-wrapper') || tmp.querySelector('.card');
          /* Return a clone so the node is never "moved" out of tmp */
          return card ? card.cloneNode(true) : null;
        })
        .catch(function () { return null; });
    };

    /* Fetch recommendation cards via section rendering */
    CbCartYmal.prototype._fetchRecCards = function (productId, count, inCart) {
      var recUrl = (window.routes && window.routes.product_recommendations_url) || '/recommendations/products';
      return fetch(
        recUrl + '?product_id=' + productId + '&limit=' + (count + 6) + '&section_id=cb-cart-recs-helper',
        { headers: { Accept: 'text/html' } }
      )
        .then(function (r) { return r.ok ? r.text() : ''; })
        .then(function (html) {
          var tmp = document.createElement('div');
          tmp.innerHTML = html;
          var seen = {}, cards = [];
          tmp.querySelectorAll('.card-wrapper').forEach(function (card) {
            var a = card.querySelector('a[href*="/products/"]');
            if (!a) return;
            var h = (a.getAttribute('href').split('/products/')[1] || '').split('?')[0].toLowerCase();
            if (!h || seen[h] || inCart.indexOf(h) !== -1) return;
            seen[h] = true;
            /* Clone immediately — querySelectorAll returns live DOM nodes */
            cards.push(card.cloneNode(true));
          });
          return cards.slice(0, count);
        })
        .catch(function () { return []; });
    };



    CbCartYmal.prototype._makeLi = function (cardEl) {
      var li = document.createElement('li');
      li.className = 'grid__item cb-cart-ymal-item';
      /* cardEl from _fetchRVCard is already a clone; recCards are from querySelectorAll
         so we always clone to be safe and avoid moving nodes */
      li.appendChild(cardEl.cloneNode(true));
      injectATBOverlay(li, {
        overlayClass: 'cb-ymal-atb-overlay',
        btnClass:     'cb-ymal-atb-btn',
        reloadAfter:  true
      });
      return li;
    };

    CbCartYmal.prototype._skeleton = function (row, n) {
      row.innerHTML = '';
      for (var i = 0; i < n; i++) {
        var li = document.createElement('li');
        li.className = 'grid__item';
        li.innerHTML = '<div class="cb-cart-skeleton"></div>';
        row.appendChild(li);
      }
    };

    CbCartYmal.prototype._boot = function () {
      var self  = this;
      var total = parseInt(self.dataset.total, 10) || 4;
      var maxRv = parseInt(self.dataset.maxRv,  10);
      if (isNaN(maxRv)) maxRv = 3;
      var row  = self.querySelector('[data-cb-ymal-row]');
      var wrap = self.closest('.cb-cart-ymal-wrap');
      if (!row) return;

      var inCart = self._cartHandles();
      var anchor = inCart[0];

      /* RV candidates — not in cart */
      var rvCandidates = getRVList()
        .filter(function (h) { return inCart.indexOf(h) === -1; })
        .slice(0, maxRv);

      /* If no RV history AND no cart item, nothing to show */
      if (rvCandidates.length === 0 && !anchor) {
        if (wrap) wrap.style.display = 'none';
        return;
      }

      /* Show skeletons */
      self._skeleton(row, total);
      if (wrap) wrap.style.display = '';  /* show the wrap immediately (with skeletons) */

      var rvCount  = rvCandidates.length;
      var recCount = total - rvCount;

      /* Fetch RV cards */
      var rvPromise = rvCount > 0
        ? Promise.all(rvCandidates.map(function (h) { return self._fetchRVCard(h); }))
        : Promise.resolve([]);

      /* Fetch rec cards */
      var recPromise = (recCount > 0 && anchor)
        ? fetch('/products/' + encodeURIComponent(anchor) + '.js', { headers: { Accept: 'application/json' } })
            .then(function (r) { return r.ok ? r.json() : null; })
            .then(function (p) {
              if (!p) return [];
              return self._fetchRecCards(String(p.id), recCount + rvCount, inCart);
            })
            .catch(function () { return []; })
        : Promise.resolve([]);

      Promise.all([rvPromise, recPromise])
        .then(function (results) {
          var rvEls  = results[0].filter(Boolean);
          var recEls = results[1];

          /* Fill any RV shortfall from recs */
          var rvShortfall = rvCount - rvEls.length;
          var allEls = rvEls.concat(recEls.slice(0, recCount + rvShortfall)).slice(0, total);

          if (!allEls.length) {
            if (wrap) wrap.style.display = 'none';
            return;
          }

          row.innerHTML = '';
          allEls.forEach(function (el) { row.appendChild(self._makeLi(el)); });
          if (wrap) wrap.style.display = '';
        })
        .catch(function () {
          if (wrap) wrap.style.display = 'none';
        });
    };

    window.customElements.define('cb-cart-ymal', CbCartYmal);
  }

  /* ══════════════════════════════════════════════════════════════════════════
     4. DISCOUNT AUTO-CLEAR ON EMPTY CART
  ══════════════════════════════════════════════════════════════════════════ */
  (function () {
    var busy = false;

    function wipeDom() {
      document.querySelectorAll(
        '[data-cart-discount-applied], .cart-discount__applied-list, .cart-drawer__footer .discounts'
      ).forEach(function (el) { el.innerHTML = ''; });
    }

    function nuke() {
      if (busy) return; busy = true;
      fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ discount: '' })
      })
        .then(function (r) { return r.json(); })
        .then(function () {
          busy = false; wipeDom();
          if (document.getElementById('main-cart-footer')) {
            fetch(window.location.pathname, { headers: { Accept: 'text/html' } })
              .then(function (r) { return r.text(); })
              .then(function (html) {
                var tmp = document.createElement('div'); tmp.innerHTML = html;
                ['main-cart-items', 'main-cart-footer'].forEach(function (id) {
                  var src = tmp.querySelector('#' + id), dst = document.getElementById(id);
                  if (src && dst) dst.innerHTML = src.innerHTML;
                });
              }).catch(function () {});
          }
        })
        .catch(function () { busy = false; });
    }

    function check() {
      fetch('/cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (c) {
          if (c.item_count === 0) {
            wipeDom();
            if (c.discount_codes && c.discount_codes.length) nuke();
          }
        }).catch(function () {});
    }

    document.addEventListener('click', function (e) {
      if (e.target.closest('cart-remove-button')) { setTimeout(check, 700); setTimeout(check, 1500); }
    });
    (function hookPS() {
      if (window.PUB_SUB_EVENTS && typeof subscribe === 'function') {
        subscribe(PUB_SUB_EVENTS.cartUpdate, function (e) {
          if (e && e.source === 'cart-discount') return;
          setTimeout(check, 500);
        });
      } else setTimeout(hookPS, 400);
    })();
    document.addEventListener('change', function (e) {
      if (e.target.closest('.quantity__input') && parseInt(e.target.value, 10) === 0) setTimeout(check, 1200);
    });
    function onLoad() {
      if (window.location.pathname.indexOf('/cart') !== -1 ||
          document.querySelector('cart-items') ||
          document.getElementById('main-cart-footer')) check();
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', onLoad);
    else onLoad();
  })();

  /* ══════════════════════════════════════════════════════════════════════════
     5. CROSS-SECTION DEDUPLICATION WITH PRIORITY + FALLBACK COUNT
     Sections are processed in priority order (highest first). Each section
     claims its unique products; lower-priority sections lose any overlap.
     After dedup each section is trimmed to the nearest multiple of 4
     (16 → 12 → 8 → 4) and hidden entirely if fewer than 4 unique products
     remain. Recently-viewed is excluded from dedup (personal history) and has
     no minimum count — it shows everything or hides when empty.
  ══════════════════════════════════════════════════════════════════════════ */
  var dedupTimer = null;

  /* Priority order: index 0 = highest priority */
  var CB_DEDUP_ORDER = [
    'more-from-collection',
    'similar-products',
    'related-products',
    'inspired-by'
  ];

  function getShopifyWrapper(el) {
    return el.closest('.shopify-section') || el;
  }

  function deduplicateRecommendations() {
    var seen = {};

    CB_DEDUP_ORDER.forEach(function (key) {
      var section = document.querySelector('[data-cb-section="' + key + '"]');
      if (!section) return;

      var grid = section.querySelector('.product-grid');
      if (!grid) return;

      var allItems = Array.prototype.slice.call(
        grid.querySelectorAll('li.grid__item[data-product-id]')
      );
      if (!allItems.length) return;

      /* Step 1 — remove duplicates already claimed by higher-priority sections */
      var unique = [];
      allItems.forEach(function (li) {
        var pid = li.dataset.productId;
        if (seen[pid]) {
          li.remove();
        } else {
          seen[pid] = true;
          unique.push(li);
        }
      });

      /* Step 2 — fallback count: round down to nearest multiple of 4 */
      var kept   = unique.length;
      var target = Math.floor(kept / 4) * 4;

      if (target === 0) {
        getShopifyWrapper(section).style.display = 'none';
        return;
      }

      /* Remove any cards beyond the target count */
      unique.slice(target).forEach(function (li) { li.remove(); });

      /* Ensure the wrapper is visible */
      getShopifyWrapper(section).style.display = '';
    });

    /* Recently-viewed: no dedup against other sections, no minimum count.
       The section's own JS already removes itself when empty. */
  }

  function scheduleDedup() {
    clearTimeout(dedupTimer);
    dedupTimer = setTimeout(deduplicateRecommendations, 200);
  }

  /* ══════════════════════════════════════════════════════════════════════════
     6. BOOTSTRAP
  ══════════════════════════════════════════════════════════════════════════ */
  function init() {
    decorateUpsellCards(document);
    decorateRVCards(document);
    scheduleDedup();

    document.addEventListener('shopify:section:load', function (e) {
      decorateUpsellCards(e.target || document);
      decorateRVCards(e.target || document);
      scheduleDedup();
    });

    /* Watch for dynamically injected cards (RV section loads async) */
    if (window.MutationObserver) {
      var mo = new MutationObserver(debounce(function (mutations) {
        var needsUpsell = false, needsRV = false, needsDedup = false;
        mutations.forEach(function (m) {
          m.addedNodes.forEach(function (node) {
            if (node.nodeType !== 1) return;
            if (node.querySelector && node.querySelector('[data-recently-viewed-grid]')) needsRV = true;
            if (node.closest && node.closest('[data-recently-viewed-grid]')) needsRV = true;
            if (node.classList && node.classList.contains('cb-card-item')) { needsUpsell = true; needsDedup = true; }
            if (node.querySelector && node.querySelector('.cb-card-item')) { needsUpsell = true; needsDedup = true; }
          });
        });
        if (needsUpsell) decorateUpsellCards(document);
        if (needsRV)     decorateRVCards(document);
        if (needsDedup)  scheduleDedup();
      }, 100));
      mo.observe(document.body, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

})();
